module.exports = __webpack_public_path__ + "img/fourday_ps_20.84dd63c6.jpg";